const helper = {
  pad( number ) {
    return ( '0' + number ).slice( -2 )
  }
}

export function getTime( duration ) {
  const minutes = Math.floor( duration / 1000 / 60 )
  const second = Math.floor( duration / 1000 - minutes * 60 )
  return `${helper.pad( minutes )}:${helper.pad( second )}`
}
export default helper